import React from 'react';
import '../../styles/event.css';
import { choose } from '../../utils/platform';
import { useEvents } from './useEvents';
import EventsDesktop from './Events.desktop';
import EventsMobile from './Events.mobile';

const EventsView = choose(EventsDesktop, EventsMobile);

export default function Events() {
  const vm = useEvents();
  return <EventsView vm={vm} />;
}
